const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Agu', 'Sep', 'Okt', 'Nov', 'Des']

/** Formats an ISO date (YYYY-MM-DD or full timestamp) as "7 Mei 2025" without depending on the runtime locale. */
export const formatDate = (value: string | null | undefined): string => {
    if (!value) return ''

    const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value)
    if (!match) return value

    const [, year, month, day] = match
    const monthLabel = MONTHS[Number(month) - 1]

    if (!monthLabel) return value

    return `${Number(day)} ${monthLabel} ${year}`
}

/** The year of an ISO date, for example "2025". */
export const formatYear = (value: string | null | undefined): string => {
    if (!value) return ''

    const match = /^(\d{4})/.exec(value)
    return match ? match[1] : ''
}

export const pad = (value: number, size = 2): string => String(value).padStart(size, '0')

export const slugify = (value: string): string => value
    .toLowerCase()
    .replace(/&/g, 'dan')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
